import { Injectable } from '@angular/core';
import { AdviceCategory, ArticleDetails } from '../models/advice.models';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class AdviceService {
	constructor(private _router: Router) {}

	getArticleId = (allArticles: any, category: string, articleUrl: string): number => {
		const artId = allArticles[category].filter(
			(article: any) => article.url === articleUrl,
		);

		return artId.length === 0 ? 0 : artId[0].art_id;
	};

	getCategoryId = (categories: any, key: string) => {
		const res = categories.filter((cat: any) => cat.name.toLowerCase() === key);
		return res[0].id;
	};

	redirectFromIncorrectUrl(categoryUrl: string, subPath = ''): boolean {
		if (categoryUrl === 'student-advice') {
			subPath
				? this._router.navigate(['/advice/student/', subPath])
				: this._router.navigate(['/advice/student/']);
			return false;
		} else if (categoryUrl === 'student-bank-account') {
			subPath
				? this._router.navigate([
						'/advice/student-finance/best-student-bank-account/',
						subPath,
					])
				: this._router.navigate([
						'/advice/student-finance/best-student-bank-account/',
					]);

			return false;
		}

		return true;
	}

	//non http data
	getCategoryDetails = (category: string): ArticleDetails => {
		const result: ArticleDetails = {
			seoTitle: '',
			seoDescription: '',
			headerTitle: '',
			headerDescription: '',
			aboutTitle: '',
			aboutDescription: '',
			key: '',
			articlesTitle: '',
			url: '',
			img: '',
			catTitle: '',
			catDescription: '',
			relatedCategories: [],
			error: false,
			showReadMoreButton: false,
		};

		const titleFragment = ' Advice & Tips';
		const generateDescription = (str: string, preposition = 'on') => {
			return (
				'Browse our advice hub for blogs, articles and tips ' +
				preposition +
				' ' +
				str +
				'. We provide expert advice and guidance to give you all the information you need!'
			);
		};

		switch (category) {
			case 'student':
				result.seoTitle = 'Student' + titleFragment;
				result.seoDescription = generateDescription('university students', 'for');
				result.headerTitle = 'General Student Advice Articles';
				result.headerDescription =
					'In this section, we’ll give you all the general advice you need when studying at university or college as well as some information regarding A Levels, GCSEs, T Levels and university entrance exams.';
				result.aboutTitle = 'About Student Advice';
				result.aboutDescription = `<span>
                Our general advice section is the perfect place to come for students that are looking to learn about everything. In this section, we’ll take a look at some of the different university courses you will come across, how to handle university open days, the different kinds of university entrance exams and what life is like at university.
                </span>
                <span class="articles-about hidden">We don’t just look at the studying side of university, we also take a look at how to look after your mental health, how to change universities and how to remain healthy and fit!
                With the general advice section, we define the undefinables and provide you with accurate and up-to-date information on university life and arm you with the tools to breeze through university.</span>`;
				result.key = 'Student_Advice';
				result.articlesTitle = 'General Student Advice Articles';
				result.showReadMoreButton = true;
				(result.url = 'student'),
					(result.img = '/assets/img/student_advice_icon.svg'),
					(result.catTitle = 'General'),
					(result.catDescription =
						'A collection of articles about everything at university.'),
					(result.relatedCategories = [
						'personal-statement',
						'ucas',
						'student-finance',
						'postgraduate',
					]);
				break;
			case 'gcses':
				result.seoTitle = 'GCSE&#39;s' + titleFragment;
				result.seoDescription = generateDescription('GCSE&#39;s');
				result.headerTitle = 'GCSE Advice';
				result.headerDescription =
					'Our GCSE category covers everything you need to know about the world of GCSEs, from choosing your GCSE subjects, working to your study goals, revision tips and how to retake your GCSEs.';
				result.aboutTitle = 'About GCSE and School';
				result.aboutDescription = `<span>
                Key Stage 4 education is coming to a close and for some people, it's the end of education as
                they know it! Here we have everything a growing GCSE student could ever need! We've got
                advice on choosing your GCSE subjects, getting a job</span>
                <span class="articles-about hidden"> during your GCSEs, GCSE work experience and how to cope with
                the stress of GCSEs, as well as general advice on when GCSEs start and retaking GCSEs for
                adults.</span>`;
				result.key = 'GCSEs';
				result.showReadMoreButton = true;
				result.articlesTitle = 'GCSE and School Articles';
				(result.url = 'gcses'),
					(result.img = '/assets/img/GCSE_icon.svg'),
					(result.catTitle = 'GCSEs'),
					(result.catDescription =
						"We've got revision guides, career advice and even snack advice all here!"),
					(result.relatedCategories = [
						'a-levels',
						'personal-statement',
						'ucas',
						'accommodation',
					]);
				break;
			case 'a-levels':
				result.seoTitle = 'A Level Tips | A Level Advice';
				result.seoDescription = generateDescription('A Levels');
				result.headerTitle = "A Levels & Scottish Higher's";
				result.headerDescription =
					'Our A Level section covers everything from retaking A-Levels through to what to expect on AS Level Results Day and A Level Results Day.';
				result.aboutTitle = "About A Levels & Scottish Higher's";
				result.aboutDescription =
					"A Levels are the final steps before university. Whether you're taking general A-Levels or you're looking into online A Levels, there are plenty of resources available for you here, which show you everything you need to smash Key Stage 5! Learn about A Level Results Day and learn about A Level revision tips all in one place!";
				result.key = 'A_Levels';
				result.articlesTitle = "A Levels & Scottish Higher's Articles";
				(result.url = 'a-levels'),
					(result.img = '/assets/img/a_levels_icon.svg'),
					(result.catTitle = 'A Levels'),
					(result.catDescription =
						'Find the best A Level advice right here, dig inside and get reading.'),
					(result.relatedCategories = [
						'personal-statement',
						'ucas',
						'student',
						'accommodation',
					]);

				break;
			case 'apprenticeships':
				result.seoTitle = 'Apprenticeships' + titleFragment;
				result.seoDescription = generateDescription('on apprenticeships');
				result.headerTitle = 'Apprenticeships';
				result.headerDescription =
					'Our Apprenticeships section gives you an insight into the world of apprenticeships, how they work, how much you can be paid and how to study abroad.';
				result.aboutTitle = 'About Apprenticeships';
				result.aboutDescription =
					'Apprenticeships give you a great insight into the world of work, education and workplace experience. We’ll show you how to apply for apprenticeships abroad, give you the lowdown on what apprenticeships are and how they work and we’ll give you an insight into what kind of wage you can expect while working as an apprentice.';
				result.key = 'Apprenticeships';
				result.articlesTitle = 'Apprenticeship Articles';
				(result.url = 'apprenticeships'),
					(result.img = '/assets/img/apprenticeships_icon.svg'),
					(result.catTitle = 'Apprenticeships'),
					(result.catDescription =
						'Everything you need to know about private, degree and government'),
					(result.relatedCategories = [
						'student-finance',
						'gap-year',
						'student',
						'ucas',
					]);
				break;
			case 'student-finance':
				result.seoTitle = 'Student Finance' + titleFragment;
				result.seoDescription = generateDescription('student finance');
				result.headerTitle = 'Student Finance';
				result.headerDescription =
					'Our student finance section focuses on applying for student finance, how student finance works in the UK, whether or not students pay tax and information on student council tax.';
				result.aboutTitle = 'About Student Finance';
				result.aboutDescription =
					'<span> Student finance is very important when you’re at university. Your student loan is a major part of how you will study your course and how you will manage your student accommodation. In this section, we will show you everything you need to know about student finance, scholarships, bursaries and grants.<br> </span><span class="articles-about hidden"> We will also take a deeper look into specific student bursaries, such as the NHS bursary and the Disabled Students Allowance as well as an in-depth look at student council tax and student contents insurance.</span>';
				result.key = 'Student_Finance';
				result.articlesTitle = 'Student Finance Articles';
				result.showReadMoreButton = true;
				(result.url = 'student-finance'),
					(result.img = '/assets/img/student_finance_icon.svg'),
					(result.catTitle = 'Student Finance'),
					(result.catDescription =
						"Student finance is a pain, luckily, we've got all the advice you'll need."),
					(result.relatedCategories = [
						'student',
						'apprenticeships',
						'personal-statement',
						'ucas',
					]);
				break;
			case 'gap-year':
				result.seoTitle = 'Gap Year' + titleFragment;
				result.seoDescription = generateDescription('university gap years');
				result.headerTitle = 'Gap Years';
				result.headerDescription =
					'Learn more about what to do on a gap year, how to prepare, common mistakes and the various places that you can travel to on the various gap year programs available to you!';
				result.aboutTitle = 'About Gap Year and Travelling';
				result.aboutDescription =
					'<span>A gap year is a great opportunity to find out more about yourself and to discover some of the most gorgeous places on the planet. Our gap year advice articles will arm you with all the advice you need to begin your gap year journey!</span> <span class="articles-about hidden"> We will talk you through the common gap year mistakes students often make, the pros and cons of a gap year and we’ll even give you an idea of the various gap year destinations everyone should visit!</span>';
				result.key = 'Gap_Year';
				result.articlesTitle = 'Gap Year and Travelling Articles';
				result.showReadMoreButton = true;
				(result.url = 'gap-year'),
					(result.img = '/assets/img/gap_year_icon.svg'),
					(result.catTitle = 'Gap Year'),
					(result.catDescription =
						'Gap year guides, advice and pros and cons, are all right here for you!'),
					(result.relatedCategories = [
						'student',
						'apprenticeships',
						'personal-statement',
						'ucas',
					]);
				break;
			case 'student-health':
				result.seoTitle = 'Student Health' + titleFragment;
				result.seoDescription = generateDescription('student health');
				result.headerTitle = 'Student Health';
				result.headerDescription =
					'Our student health category takes an in-depth look at the importance of sport at university, how to deal with mental health issues, healthy student recipes and more!';
				result.aboutTitle = 'About Health and Fitness';
				result.aboutDescription =
					'Nothing is more important at university than looking after yourself. Keeping your mental and physical wellbeing in check is essential and we’ve got some of the perfect articles to help you with that! Our in-depth articles look at mental health, the importance of sport at university and some cheap and healthy student recipes for those late-night study sessions.';
				result.key = 'Student_Health';
				result.articlesTitle = 'Health and Fitness Articles';
				(result.url = 'student-health'),
					(result.img = '/assets/img/student_health_icon.svg'),
					(result.catTitle = 'Student Health'),
					(result.catDescription =
						'Keeping fit at uni is important, so this section is vital for you!'),
					(result.relatedCategories = [
						'student-finance',
						'student',
						'apprenticeships',
						'ucas',
					]);
				break;
			case 'personal-statement':
				result.seoTitle = 'Personal Statement' + titleFragment;
				result.seoDescription = generateDescription('personal statements');
				result.headerTitle = 'Personal Statements';
				result.headerDescription =
					'Our UCAS personal statement category is essential for any students stuck writing that dreaded personal statement.';
				result.aboutTitle = 'About Personal Statements';
				result.aboutDescription =
					'<span> A university personal statement is an essential part of your university application. Whether you’re applying directly or going through UCAS, your personal statement is often the decider for universities. In this section, we will arm you with everything you could ever need to begin writing your personal statement. </span> <span class="articles-about hidden"> We’ll look at how to write your personal statement, what to include and we’ll show you to start crafting a postgraduate personal statement as well.</span>';
				result.key = 'Personal_Statement';
				result.articlesTitle = 'Personal Statement Articles';
				result.showReadMoreButton = true;
				(result.url = 'personal-statement'),
					(result.img = '/assets/img/personal_statement_icon.svg'),
					(result.catTitle = 'Personal Statement'),
					(result.catDescription =
						'Advice on how to write your personal statement, what to include and more!'),
					(result.relatedCategories = [
						'a-levels',
						'student',
						'accommodation',
						'ucas',
					]);
				break;
			case 'studying-abroad':
				result.seoTitle = 'Studying Abroad' + titleFragment;
				result.seoDescription = generateDescription('studying abroad');
				result.headerTitle = 'Study Abroad Advice';
				result.headerDescription =
					'Our Study Abroad category covers everything from studying abroad, travel for students, the benefits of studying abroad, why you should study at a university abroad and more.';
				result.aboutTitle = 'About Studying Abroad';
				result.aboutDescription =
					'Not all students want to stay in the UK. Many students want to explore the big wide world and take their education to the next level, maybe even another continent! If you are looking to study abroad, then we’ve got everything you need to know about study abroad programmes and more, here.';
				result.key = 'Studying_Abroad';
				result.articlesTitle = 'Study Abroad Articles';
				(result.url = 'studying-abroad'),
					(result.img = '/assets/img/studying_abroad_icon.svg'),
					(result.catTitle = 'Studying Abroad'),
					(result.catDescription =
						'Discover everything you need to know about studying abroad here.'),
					(result.relatedCategories = [
						'student',
						'gap-year',
						'personal-statement',
						'ucas',
					]);
				break;
			case 'teacher':
				result.seoTitle = 'Teacher' + titleFragment;
				result.seoDescription = generateDescription('teacher advice');
				result.headerTitle = 'Teacher Advice';
				result.headerDescription =
					'Our teacher advice section provides you with in-depth articles that give you advice and suggestions about helping your students.';
				result.aboutTitle = 'Advice for Teachers';
				result.aboutDescription =
					'In this section, we aim to make the pain points a little more manageable. Here, we will show you how to advise your students who want to study abroad, how to start writing a UCAS reference and how to maintain your work-life balance.';
				result.key = 'Teacher';
				result.articlesTitle = 'Teacher/School Articles';
				(result.url = 'teacher'),
					(result.img = '/assets/img/teacher_advice_icon.svg'),
					(result.catTitle = 'Teacher Advice'),
					(result.catDescription =
						'Advice for teachers, by teachers, all you need to help your students!'),
					(result.relatedCategories = [
						'student',
						'apprenticeships',
						'personal-statement',
						'ucas',
					]);
				break;
			case 'ucas':
				result.seoTitle = 'UCAS' + titleFragment;
				result.seoDescription = generateDescription('UCAS');
				result.headerTitle = 'UCAS Advice';
				result.headerDescription =
					'In our UCAS section, we cover everything you need to know about UCAS, UCAS points and UCAS application advice.';
				result.aboutTitle = 'About UCAS';
				result.aboutDescription =
					'<span> We have a great list of UCAS advice articles available for you right here. Everything you need to now about your UCAS application, applying to university with a disability, UCAS clearing advice, UCAS careers advice and general UCAS and</span> <span class="articles-about hidden"> university application information is here and can show you how to go about applying for university.</span>';
				result.key = 'UCAS';
				result.articlesTitle = 'UCAS Articles';
				result.showReadMoreButton = true;
				(result.url = 'ucas'),
					(result.img = '/assets/img/UCAS_advice_icon.svg'),
					(result.catTitle = 'UCAS Advice'),
					(result.catDescription =
						'How to apply for university and how to track your application, is all here.'),
					(result.relatedCategories = [
						'student-finance',
						'apprenticeships',
						'personal-statement',
						'student',
					]);
				break;
			case 'accommodation':
				result.seoTitle = 'Student Accommodation' + titleFragment;
				result.seoDescription = generateDescription(
					'university student accommodation',
				);
				result.headerTitle = 'Accommodation and Housing';
				result.headerDescription =
					'Our student accommodation articles tell you the dos and don’ts of student accommodation, in this section, we look at general student accommodation tips, house-viewing checklists, tips for living at university and tips for living in student halls.';
				result.aboutTitle = 'Student Accommodation';
				result.aboutDescription =
					'Student accommodation is part of the university experience and here we have all the information you need. We have a house viewing checklist, useful information on student halls and general advice for living at university. You can also pick some useful financial tips for accommodation for students and some general tips for getting on with housemates too.';
				result.key = 'Accommodation';
				result.articlesTitle = 'Accommodation and Housing Articles';
				(result.url = 'accommodation'),
					(result.img = '/assets/img/accomodation_icon.svg'),
					(result.catTitle = 'Accommodation'),
					(result.catDescription =
						'Find out everything you need to know about uni accommodation and halls.'),
					(result.relatedCategories = [
						'student-finance',
						'student',
						'ucas',
						'personal-statement',
					]);
				break;
			case 'postgraduate':
				result.seoTitle = 'Postgraduate' + titleFragment;
				result.seoDescription = generateDescription('postgraduates', 'for');
				result.headerTitle = 'Postgraduate, PHD and Masters';
				result.headerDescription =
					'Our postgraduate section takes a look at all elements of postgraduate study, whether it be writing your personal statement, identifying the different degree types or student finance.';
				result.aboutTitle = 'About Postgraduate, PHD and Masters';
				result.aboutDescription =
					'<span>Our postgraduate section gives you an in-depth look at postgraduate study. In this section, we will look at everything you need from a Master’s degree, to a PGCE degree all the way through to a PhD.  </span> <span class="articles-about hidden">Our postgraduate section will tell you everything you need to know about postgraduate study and will give you an insight into what postgraduate study is like at university.</span>';
				result.key = 'Postgraduate';
				result.articlesTitle = 'Postgraduate, PHD and Masters Articles';
				result.showReadMoreButton = true;
				(result.url = 'postgraduate'),
					(result.img = '/assets/img/post_graduate_icon.svg'),
					(result.catTitle = 'Postgraduate'),
					(result.catDescription =
						'A compendium of everything you need to know about postgraduate study.'),
					(result.relatedCategories = [
						'student-finance',
						'student',
						'ucas',
						'personal-statement',
					]);
				break;
			case 'clearing':
				result.seoTitle = 'Clearing' + titleFragment;
				result.seoDescription = generateDescription('clearing');
				result.headerTitle = 'Clearing';
				result.headerDescription =
					'Find out more about Clearing! We have everything you need to know regarding Clearing, Adjustment, how to enter Clearing and how Clearing works in UCAS.';
				result.aboutTitle = 'About Clearing';
				result.aboutDescription =
					'<span>Clearing is how universities and colleges fill empty places on their courses. If you haven’t gotten the results you needed for your firm offer or if you hadn’t accepted a place at a university, you are eligible for Clearing. Learn about the UCAS Clearing process, how to search for Clearing courses and more all in one place!</span>';
				result.key = 'Clearing';
				result.articlesTitle = 'Clearing Articles';
				(result.url = 'clearing'),
					(result.img = '/assets/img/post_graduate_icon.svg'),
					(result.catTitle = 'Clearing'),
					(result.catDescription =
						'Everything you need to know about Clearing all in one place!'),
					(result.relatedCategories = [
						'student-finance',
						'student',
						'ucas',
						'apprenticeships',
					]);
				break;
			case 'work-experience':
				result.seoTitle = 'Work' + titleFragment;
				result.seoDescription = generateDescription('work experience');
				result.headerTitle = 'Work Advice';
				result.headerDescription =
					'In our work category, we will give you all the information you need on internships, apprenticeships, work experience, how to apply for jobs and more.';
				result.aboutTitle = 'About Work Advice';
				result.aboutDescription =
					"<span>You don't need to have left university to work. Many students take on part-time jobs while at college or university and many step into the world of work as soon as they’ve finished their A-Levels. We’ve got everything you need to know about apprenticeships, work experience, online work experience, internships and everything in-between right here.</span>";
				result.key = 'Work_experience';
				result.articlesTitle = 'Work Advice';
				(result.url = 'work-experience'),
					(result.img = '/assets/img/work_advice_icon.svg'),
					(result.catTitle = 'Work Advice'),
					(result.catDescription =
						'Find the best advice about working today. Discover your next steps here.'),
					(result.relatedCategories = [
						'student-finance',
						'student',
						'ucas',
						'apprenticeships',
					]);
				break;
			case 'international-students':
				result.seoTitle = 'Advice for International Students | Study in the UK';
				result.seoDescription =
					'For international and EU students looking to apply for university in the UK, start right here! Find advice on how to apply and what you can expect from the UK university experience.';
				result.headerTitle = 'Advice for studying in the UK';
				result.headerDescription =
					'Learn more about how to apply to a university in the UK from abroad with our ultimate guides! Discover all the advice you need from applying for visas, finding accommodation and what to expect from the experience.';
				result.aboutTitle = 'About studying in the UK';
				result.aboutDescription =
					'UK universities are like no other, there’s no wonder they’re world renowned! Like every country, we do things a little differently, so here we break down all there is to consider as an international or EU student coming to the UK. ';
				result.key = 'International_Students';
				result.articlesTitle = 'International Student Articles';
				(result.url = 'international-students'),
					(result.img = '/assets/img/international_students_advice.svg'),
					(result.catTitle = 'International Students'),
					(result.catDescription =
						'Looking to study in the UK? From visas to UK culture, we’ve got you covered.'),
					(result.relatedCategories = [
						'ucas',
						'studying-abroad',
						'postgraduate',
						'student',
					]);
				break;
			default:
				result.error = true;
		}

		return result;
	};

	getCategoryMeta = (): AdviceCategory[] => {
		return [
			{
				key: 'A_Levels',
				url: 'a-levels',
				img: '/assets/img/a_levels_icon.svg',
				catTitle: 'A Levels',
				catDescription:
					'Find the best A Level advice right here, dig inside and get reading.',
			},
			{
				key: 'Accommodation',
				url: 'accommodation',
				img: '/assets/img/accomodation_icon.svg',
				catTitle: 'Accommodation',
				catDescription:
					'Find out everything you need to know about uni accommodation and halls.',
			},
			{
				key: 'Apprenticeships',
				url: 'apprenticeships',
				img: '/assets/img/apprenticeships_icon.svg',
				catTitle: 'Apprenticeships',
				catDescription:
					'Everything you need to know about private, degree and government',
			},
			{
				key: 'Gap_Year',
				url: 'gap-year',
				img: '/assets/img/gap_year_icon.svg',
				catTitle: 'Gap Year',
				catDescription:
					'Gap year guides, advice and pros and cons, are all right here for you!',
			},
			{
				key: 'GCSEs',
				url: 'gcses',
				img: '/assets/img/GCSE_icon.svg',
				catTitle: 'GCSE',
				catDescription:
					"We've got revision guides, career advice and even snack advice all here!",
			},
			{
				key: 'Student_Advice',
				url: 'student',
				img: '/assets/img/student_advice_icon.svg',
				catTitle: 'General',
				catDescription:
					'A collection of articles about everything at university.',
			},
			{
				key: 'Personal_Statement',
				url: 'personal-statement',
				img: '/assets/img/personal_statement_icon.svg',
				catTitle: 'Personal Statement',
				catDescription:
					'Advice on how to write your personal statement, what to include and more!',
			},
			{
				key: 'Postgraduate',
				url: 'postgraduate',
				img: '/assets/img/post_graduate_icon.svg',
				catTitle: 'Postgraduate',
				catDescription:
					'A compendium of everything you need to know about postgraduate study.',
			},
			{
				key: 'Student_Finance',
				url: 'student-finance',
				img: '/assets/img/student_finance_icon.svg',
				catTitle: 'Student Finance',
				catDescription:
					"Student finance is a pain, luckily, we've got all the advice you'll need.",
			},
			{
				key: 'Student_Health',
				url: 'student-health',
				img: '/assets/img/student_health_icon.svg',
				catTitle: 'Student Health',
				catDescription:
					'Keeping fit at uni is important, so this section is vital for you!',
			},
			{
				key: 'Studying_Abroad',
				url: 'studying-abroad',
				img: '/assets/img/studying_abroad_icon.svg',
				catTitle: 'Studying Abroad',
				catDescription:
					'Discover everything you need to know about studying abroad here.',
			},
			{
				key: 'Teacher',
				url: 'teacher',
				img: '/assets/img/teacher_advice_icon.svg',
				catTitle: 'Teacher Advice',
				catDescription:
					'Advice for teachers, by teachers, all you need to help your students!',
			},
			{
				key: 'UCAS',
				url: 'ucas',
				img: '/assets/img/UCAS_advice_icon.svg',
				catTitle: 'UCAS Advice',
				catDescription:
					'How to apply for university and how to track your application, is all here.',
			},
			{
				key: 'Work_experience',
				url: 'work-experience',
				img: '/assets/img/work_advice_icon.svg',
				catTitle: 'Work Advice',
				catDescription:
					'Find the best advice about working today. Discover your next steps here.',
			},
			{
				key: 'International_Students',
				url: 'international-students',
				img: '/assets/img/international_students_advice.svg',
				catTitle: 'International Students',
				catDescription:
					'Looking to study in the UK? From visas to UK culture, we’ve got you covered.',
			},
		];
	};
}
